export default __webpack_public_path__ + "fonts/person-icon-map.svg";